import MUIToolbar, { ToolbarProps } from "@mui/material/Toolbar";
import React, { FC } from "react";

export const Toolbar: FC<ToolbarProps> = (props) => (
  <MUIToolbar {...props} />
);
